module.exports = __webpack_public_path__ + "img/filter.768cda4f.svg";